module.exports = __webpack_public_path__ + "static/media/onde-comprar-locationpin.d002f594.svg";